module.exports = __webpack_public_path__ + "img/hipster_job_eyecatch.b2f542fe.png";